import * as yup from 'yup';

const emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);

export const userSchema = yup.object().shape({
  email: yup.string().required().matches(emailRegex, 'Email is not valid').label('Email'),
  role: yup.string().required().label('Access level'),
  projects: yup
    .array()
    .of(yup.number().required())
    .required()
    .when('role', {
      is: (role: string) => {
        return role === 'user';
      },
      then: (schema) =>
        schema.test({
          message: 'Select at least 1 project',
          test: (arr) => arr.length >= 1,
        }),
      otherwise: (schema) => schema.notRequired().transform(() => []),
    })
    .label('Project'),
});
